<template>
  <div class="header-wrapper header-wrapper--row">
    <h1 class="h1">{{ helpSettings[lang]?.help_title || 'Help' }}</h1>
    <div class="langs-group">
      <a class="label-lang" @click="setLang('en')" :class="{'current-lang': lang === 'en'}" >
        <span>Eng</span>
      </a>
      <a class="label-lang" @click="setLang('ch')" :class="{'current-lang': lang === 'ch'}">
        <span>中文</span>
      </a>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data: () => ({

  }),
  created() {

  },
  computed: {
    ...mapGetters([
      'lang'
    ]),
    ...mapGetters('app', [
      'helpSettings'
    ]),
  },
  methods: {
    ...mapActions([
      'setLang',
    ]),
  }
}
</script>
